import { AppPavilionDataMap } from './getStandsDataMap';

export const PAVILION_MAP_SLUG = 'map-for-visitors-2026';

const PAVILION_ROOM_ORDER = [
    's1',
    'm1',
    'm2',
    'm3',
    's2',
    's3',
    's4',
    's5',
    's6',
    'm4',
    'l1',
    'l2',
    'l3',
    'l4',
    'l5',
    'i1',
    'i2',
    'i3',
    'i4',
    'i5',
    'i6',
    'i7',
    'i8',
    's11',
    's10',
    's9',
    'm11',
    'm10',
    'm9',
    'm8',
    'm7',
    'm6',
    'm5',
    's8',
    's7',
] as const;

const orderIndexBySlug = new Map<string, number>(PAVILION_ROOM_ORDER.map((slug, index) => [slug, index]));

const normalizePavilionRoomSlug = (slug: string) => slug.replace(/^i-(\d)/, 'i$1');

export const getPavilionRoomSortIndex = (slug?: string) => {
    if (!slug) return Number.MAX_SAFE_INTEGER;

    const normalized = normalizePavilionRoomSlug(slug);
    return orderIndexBySlug.get(normalized) ?? Number.MAX_SAFE_INTEGER;
};

export const sortPavilionRooms = <T extends { slug?: string }>(rooms: T[]) =>
    [...rooms].sort((a, b) => getPavilionRoomSortIndex(a.slug) - getPavilionRoomSortIndex(b.slug));

export const sortPavilionRoomsRecord = (
    mapSlug: string,
    record: Record<string, AppPavilionDataMap>,
): Record<string, AppPavilionDataMap> => {
    if (mapSlug !== PAVILION_MAP_SLUG) return record;

    return Object.fromEntries(
        Object.entries(record)
            .filter(([, item]) => item != null)
            .sort(([keyA], [keyB]) => getPavilionRoomSortIndex(keyA) - getPavilionRoomSortIndex(keyB)),
    );
};
